module.exports = require('./helpers/bundle-url').getBundleURL('a5wOv') + "logo.c51670a8.svg";